import { mergeAttributes, Node,InputRule } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { history } from '@tiptap/pm/history'

import latexBlockComponent from './latexBlock.tsx'

export default Node.create({
  name: 'latexBlock',

  group: 'block',

  content: 'inline*',

  addAttributes() {
    return {
      id: {
        default: crypto.randomUUID()
      },
      metaData: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-metaData'),
        renderHTML: (attributes) => {
          return {
            'data-metaData': attributes.metaData,
          }
        },
      },
      firstCreate:{
        default:true
      },
      highlightImgUrl:{
        default:''
      },
      ifhidden: {
        default: false,
        renderHTML: attributes => {
          if (attributes.ifhidden === undefined) {
            return {};
          }
          return {
            'ifhidden': attributes.ifhidden,
          };
        },
      }
    }
  },
  parseHTML() {
    return [
      {
        tag: 'latex-block',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ['latex-block', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return (props) => {
      return ReactNodeViewRenderer(latexBlockComponent)(props);
    };
  },
  // addInputRules() {
  //   return [
  //     new InputRule({
  //       find: /\$\$(.*?)\$\$/gi, // 全局匹配 $$之间的公式
  //       handler: ({ state, range, match, chain }) => {
  //         const [, content] = match;
  //         chain()
  //             .deleteRange(range)
  //             // .insertContent(`<latex-block>${content}</latex-block>`) 不能这样写
  //             .insertContent({
  //               type: "latexBlock",
  //               attrs: {
  //                 metaData: content,
  //               }
  //             })
  //             .run();
  //       },
  //     }),
  //   ];
  // },
})